function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTruckMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.43 126.17",
    height: 28,
    width: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.72,17,96,2.22a16.59,16.59,0,0,0-16.6,0L43.61,23a8.77,8.77,0,0,0-4.39,8.16l.15,2.6L22.67,43.4a13.93,13.93,0,0,0-6,6.94c-2.78,7.12-4.87,12.46-5.89,15L8.1,67.7l-.57.5-.44.53a10.53,10.53,0,0,0-2.62,7.06v7.56L3.14,84A5.78,5.78,0,0,0,0,89.2v5.28c0,3.33.28,4.42.56,5.24a10.07,10.07,0,0,0,2,3.44l.08.08a5.16,5.16,0,0,0,.4.42,7.93,7.93,0,0,0,1,.89,8.92,8.92,0,0,0,1.11.74L39,124.79a8.49,8.49,0,0,0,4.65,1.38c1.92,0,3.57-1.15,5.22-2.16l.55-.34,4.06-2.49c2.1,1.15,5,1,8.14-.87,5.64-3.25,10.32-10.59,11.36-17.32L91.42,92c2.31,1.35,4.33,2.53,5.26,3.06,2.11,1.2,5,1,8.22-.83,5.4-3.12,9.91-10,11.2-16.45l6.22-3.42.13-.08a12.91,12.91,0,0,0,6-10.9l0-34.76A13.42,13.42,0,0,0,121.72,17Z",
    style: {
      fill: "#003173"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.49,30.61,76.05,43.25a5.67,5.67,0,0,0,5.79,0l31.06-18.9a1.82,1.82,0,0,0,0-3.14l-21-12.23a8.4,8.4,0,0,0-8.4,0l-29,17A2.72,2.72,0,0,0,54.49,30.61Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,112.59a2.37,2.37,0,0,1-2.46.07l-2.19-1.27h0L7.85,92.05v2.58A13.32,13.32,0,0,0,8,96.54a2.11,2.11,0,0,0,.2.43,2.7,2.7,0,0,0,.27.39,1.14,1.14,0,0,0,.11.11,2.25,2.25,0,0,0,.24.21,2.11,2.11,0,0,0,.27.18L42.69,117.3a2.47,2.47,0,0,0,2.68.17c1-.56,3.72-2.16,3.72-2.16s.85-.62.85-1.35v-4Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.44,51.39,50.75,38.87a4.65,4.65,0,0,0-4.65,0L26.61,50.18a6.12,6.12,0,0,0-2.58,3C22.15,58,17.43,70.08,17.39,70.1L13.2,73.66a2.87,2.87,0,0,0-.88,2.14V86.7a2.58,2.58,0,0,0,1.28,2.23l10.72,6.2V86a1.3,1.3,0,0,1,1.94-1.13l6.61,3.87a4,4,0,0,1,2,3.48v9L44,106.54a2.85,2.85,0,0,0,2.88,0l1.42-.82C49.39,99,54,91.78,59.63,88.55S69.92,87.18,71,92.61l3.87-2.23V55.65A4.92,4.92,0,0,0,72.44,51.39ZM18.2,88.29a7.65,7.65,0,0,1-3.48-6c0-2.22,1.57-3.11,3.5-2a7.65,7.65,0,0,1,3.48,6C21.69,88.51,20.12,89.4,18.2,88.29Zm22.86,13.23a7.65,7.65,0,0,1-3.48-6c0-2.22,1.57-3.11,3.5-2a7.7,7.7,0,0,1,3.48,6C44.55,101.74,43,102.63,41.06,101.52Zm9.56-31.87L46.31,81.52a1.7,1.7,0,0,1-2.45.9l-21-11.85a1.71,1.71,0,0,1-.75-2.07l4.4-11.84A1.7,1.7,0,0,1,29,55.78L49.87,67.6A1.69,1.69,0,0,1,50.62,69.65Zm18.31,4-15.36,9.2a1.1,1.1,0,0,1-1.64-1.15l3.65-10.52a9.57,9.57,0,0,1,3.33-4.77l8.75-5.29a1.28,1.28,0,0,1,2.09,1.09v10A1.68,1.68,0,0,1,68.93,73.69Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.35,95.63a15,15,0,0,0-6.82,11.81c0,4.34,3.09,6.09,6.86,3.91a15,15,0,0,0,6.82-11.81C67.2,95.2,64.13,93.45,60.35,95.63Zm0,10.79c-1.41.82-2.56.16-2.56-1.46a5.6,5.6,0,0,1,2.54-4.4c1.41-.82,2.56-.16,2.56,1.46A5.57,5.57,0,0,1,60.38,106.42Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.25,70.05a15,15,0,0,0-6.82,11.81c0,4.34,3.08,6.1,6.86,3.91A15,15,0,0,0,110.11,74C110.1,69.62,107,67.87,103.25,70.05Zm2.8,6.26a6.15,6.15,0,0,1-2.77,4.8c-1.54.89-2.79.18-2.79-1.59a6.06,6.06,0,0,1,2.77-4.8C104.8,73.83,106,74.54,106.05,76.31Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79,30.85l-31.43,19a4.53,4.53,0,0,0-2.19,3.88V84.86a2,2,0,0,0,3,1.72l3.16-2c.06-7.9,5.6-17.44,12.45-21.4,6.63-3.83,12.06-1,12.49,6.26l3-1.74a5.1,5.1,0,0,0,2.35-4.29l0-31A1.84,1.84,0,0,0,117.79,30.85Z",
    style: {
      fill: "#91c5ed"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckMap);
export default __webpack_public_path__ + "static/media/truck_map.9a96d29fe8cd189b6cdc1c544601a7b2.svg";
export { ForwardRef as ReactComponent };